// test1424
(1424 && 0);
